<template>
    <div class="investors-m">
        <p class="indent">На проведеното общо събрание на акционерите на Алкомет АД на 15.06.2022 беше гласуван нов петгодишен мандат на Надзорният съвет на Алкомет АД в състав:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Фикрет Кузуджу – Председател на Надзорния Съвет</li>
            <li class="investors-m-li">Фикрет Индже – Заместник Председател на Надзорния Съвет</li>
            <li class="investors-m-li">Семих Корай</li>
            <li class="investors-m-li">Бекир Юджел</li>
            <li class="investors-m-li">Осман Керем Кузуджу</li>
            <li class="investors-m-li">Бранимир Младенов Младенов</li>
            <li class="investors-m-li">Иван Христов Папазов</li>
        </ol>
        <p class="indent">След избора на Надзорен съвет, същият, с протокол N 90 на свое проведено заседание, избра за нов петгодишен мандат Управителен съвет в състав:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Хюсейин Йорюджю</li>
            <li class="investors-m-li">Хюсейин Умут Индже</li>
            <li class="investors-m-li">Семих Батурай</li>
            <li class="investors-m-li">Нели Кънчева Тончева</li>
            <li class="investors-m-li">Мехмет Емрах Сазак </li>
        </ol>
      <p>Считано от 12.02.2025г. дружеството се представлява и управлява от двама изпълнителни директори – Хюсейин Умут Индже и Семих Батурай.</p>
        <p class="indent">Приетата програма за корпоративно управление осигурява:</p>
        <ol class="investors-m-ol">
            <li class="investors-m-li">Защита на основните права на акционерите;</li>
            <li class="investors-m-li">Равнопоставено третиране на всички акционери, включително миноритарните и чуждестранните.</li>
            <li class="investors-m-li">Признаване правата на заинтересованите лица и насърчаване ефективното сътрудничество между дружеството и заинтересoваните лица за формиране на благосъстояние, разкриване на работни места и осигуряване на устойчиво развитие.</li>
            <li class="investors-m-li">Своевременно и точно разкриване на информация по всички въпроси, свързани с дружеството, включително и финансовото състояние, резултатите от управлението, собствеността и производствената дейност.</li>
            <li class="investors-m-li">Стратегическо управление на дружеството, ефективен контрол върху дейността на Управителния съвет и отчетността на същия пред Надзорния съвет, дружеството и акционерите.</li>
        </ol>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.investors-m p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.investors-m-ol {
  margin: 15px auto;
  list-style: decimal;
  padding-left: 20px;
  width: 60%;
}
.investors-m-li {
  display: list-item;
  font-size: 19px;
  line-height: 32px;
}
@media screen and (max-width: 1000px) {
  .investors-m > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .investors-m-ol {
    width: 100%;
    padding: 0 30px 0 50px;
  }
  .investors-m-li {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/investors/Management.vue